import { IProduct } from '../types/products'

export function discountedPrice(product?: IProduct): number {
  if (!product) return 0
  const price = Number(product.price)
  return product.discount
    ? Math.round(price - (price * Number(product.discount)) / 100)
    : price
}

export function cartCount(cart: IProduct[]): number {
  return cart.reduce((total, item) => total + (item.quantity ?? 0), 0)
}

export function cartTotal(cart: IProduct[]): number {
  return cart.reduce(
    (total, item) => total + Number(item.price) * Number(item.quantity ?? 0),
    0,
  )
}

export function quantityInCart(cart: IProduct[], id?: string): number {
  return cart.find((item) => item._id === id)?.quantity ?? 0
}

export function addProductToCart(
  cart: IProduct[],
  product: IProduct,
  quantity = 1,
): IProduct[] {
  const index = cart.findIndex((item) => item._id === product._id)

  if (index === -1) {
    return [
      ...cart,
      { ...product, quantity, price: String(discountedPrice(product)) },
    ]
  }

  return cart.map((item, i) =>
    i === index
      ? { ...item, quantity: (item.quantity ?? 0) + quantity }
      : item,
  )
}

export function setCartQuantity(
  cart: IProduct[],
  id: string,
  quantity: number,
): IProduct[] {
  if (quantity < 1) {
    return cart.filter((item) => item._id !== id)
  }

  return cart.map((item) => (item._id === id ? { ...item, quantity } : item))
}
